// Module
var code = `<div class="advanced-order-entry-main-panel">
    <div class="advanced-order-entry{{#if .attached}} attached{{/if}}">
        <div class="advanced-order-entry-list-wrapper">
            <div class="advanced-order-entry-list">
                <OEAccountLookup enabled="{{isEnabledAccountLookup}}" account="{{account}}" visible="{{accountVisible}}" />
                <OEInstrumentLookup enabled="{{isEnabledInstrumentLookup}}" instrument="{{instrument}}" account="{{account}}" name="OEInstrumentLookup" />
                <div class="oe-selector">
                    <div class="js-tercera-label">{{sideLabel}}</div>
                    <div class="oe-selector-right">
                        <reactSideToggle side="{{side}}" on-onSideChange="@this.onSideChanged(\$1)" isReverseOrder="{{reverseOrderButtons}}" />
                    </div>
                </div>

                <OEQuantity name="OEQuantity"
                            positionSizingVisible="{{positionSizingVisible}}"
                            positionSizingChecked="{{positionSizingChecked}}"
                            customCSSClass="{{qtyCustomCSSClass}}"
                            account="{{account}}"
                            instrument="{{instrument}}"
                            orderType="{{orderType}}"
                            operation="{{side}}"
                            tif="{{tif}}"
                            skipMarginRequest="{{marginOEVisible}}"
                            orderEditParameterArray="{{orderEditParameterArray}}"
                            productType="{{productType}}"
                            quantity="{{quantity}}"
                            cash="{{cash}}"
                            isCashMode="{{isCashQtyMode}}"
                            estQtyValue="{{estQtyValue}}"
                            enabled="{{!positionSizingChecked}}"
                            defaultQuantity="{{defaultQuantity}}" />

                <OEQuantity instrument="{{instrument}}"
                            visible="{{disclosedQuantityShow}}"
                            label="{{.disclosedLabel}}"
                            minValue="{{.dqMinValue}}"
                            maxValue="{{.dqMaxValue}}"
                            value="{{.disclosedQuantity.value}}"
                            tooltip="{{.dqTooltip}}"
                            valueLessMinLocalKey="{{.dqLessMinLocalKey}}"
                            valueGreaterMaxLocalKey="{{.dqGreaterMaxLocalKey}}"
                            noArrowCB="true" />

                <OEOrderTypeSelector instrument="{{instrument}}"
                                    account="{{account}}"
                                    orderType="{{orderType}}"
                                    selectedItem="{{selOrderTypeCBItem}}"
                                    forbiddenOrderTypes="{{forbiddenOrderTypes}}" />

                <OETIFSelector orderType="{{orderType}}"
                            instrument="{{instrument}}"
                            tif="{{tif}}"
                            defaultTif="{{defaultTif}}" />

                <OEProductTypeSelector instrument="{{instrument}}"
                                    account="{{account}}"
                                    productType="{{productType}}" />

                <OELeverageSelector instrument="{{instrument}}"
                                    account="{{account}}"
                                    productType="{{productType}}"
                                    leverageValue="{{leverageValue}}" />

                {{#if .isVisibleOTHTrading}}
                    <overnightExecutionControlRactive isActive="{{isAllowOTHTrading}}" 
                                                    textKey="{{overnightExecutionTextKey}}" 
                                                    tooltipKey="{{isAllowOTHTrading ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                                    controlWidth="200" 
                                                    events="{{isAllowOTHTradingEvents}}"/>
                {{/if}}

                <div class="order-edit-parameters">
                    {{>orderEditControls orderEditParameterArray}}
                </div>

                {{#if .enableComment}}
                    <OEComment userComment="{{userComment}}" on-valueChanged="onUserCommentChanged"/>
                {{/if}}

                <div class="oe-viewer-source-widget">
                    <OEQuote1Viewer delayedVisible="{{delayedVisible}}"
                                    snapshotVisible="{{snapshotVisible}}"
                                    delayedText="{{delayedText}}"
                                    snapshotText="{{snapshotText}}"
                                    instrument="{{instrument}}"
                                    account="{{account}}" />

                    <dataSourceWidget comboBoxButtonType="true" visible="{{dataSourceVisible}}" opened="{{dataSourceOpen}}" instrument="{{instrument}}" account="{{account}}" />
                </div>
            </div>
        </div>


        <div class="oe-button-place-sector">
            <OEPlaceOrderButton on-btnClick="placeOrderClick"
                                side="{{side}}"
                                tradingAllowed="{{tradingAllowed}}"
                                tradingForbiddenReason="{{tradingForbiddenReason}}"
                                additionalClass="{{placeButtonAdditionalClass}}"
                                textLocalizationKey="{{placeButtonLocalizationKey}}" />

            {{#if .isCreateOrderParmeters}}
                <terceraButton text="{{.buttonCancelText}}" terceraButtonStyle="js-button-gray25" additionalClass="{{placeButtonAdditionalClass}}" on-componentClick="btnCancelClick" />
            {{/if}}
        </div>
    </div>

    {{#if .marginOEAllowed}}
        <div class="margin-oe-open-button-container">
            <button type="button" class="margin-oe-open-button{{marginOEVisible ? ' active':''}}" on-click="onMarginOEVisibleStateChanged" as-tooltip="marginOEButtonTooltip" aria-expanded="{{marginOEVisible}}" aria-controls="marginAdvancedOrderEntry">
                <svg>
                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowRight"></use>
                </svg>
            </button>
        </div>
        <div id="marginAdvancedOrderEntry" class="margin-advanced-order-entry" style="{{^.marginOEVisible}}display:none;{{/}}">
            <marginOEControl name="marginOEControl"
                             attached="{{.attached}}"
                             visible="{{.marginOEVisible}}"
                             account="{{account}}"
                             instrument="{{instrument}}"
                             operation="{{side}}"
                             orderEditParameterArray="{{orderEditParameterArray}}"
                             orderType="{{orderType}}"
                             tif="{{tif}}"
                             amount="{{quantity}}"
                             cash="{{cash}}"
                             estQtyValue="{{estQtyValue}}"
                             isCashQtyMode="{{isCashQtyMode}}"
                             productType="{{productType}}"
                             leverageValue="{{leverageValue}}" />
        </div>
    {{/if}}
</div>`;
// Exports
export default code;